import { render, staticRenderFns } from "./xskTabs.vue?vue&type=template&id=64487b5b&scoped=true"
import script from "./xskTabs.vue?vue&type=script&lang=js"
export * from "./xskTabs.vue?vue&type=script&lang=js"
import style0 from "./xskTabs.vue?vue&type=style&index=0&id=64487b5b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_cache-loader@4.1.0_webpack@4.47.0__css-load_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64487b5b",
  null
  
)

export default component.exports